import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { roleMap } from "../../Utills/enums";
import { deleteUser, editUser, fetchUserList, openGlobalPopup } from '../../redux/action';
import MobileFilterCard from "../../component/common/MobileFilterCard";
import EmptyScreen from '../../component/common/EmptyScreen';
import UserMobileCard from "./UserMobileCard"; // We will create this next
import ConfirmBox from "../../component/Popup/ConfirmBox";
import { useTranslation } from "react-i18next";

function UserMobileList() {
    const { t } = useTranslation();
    const users = useSelector((state) => state.admin?.users) || [];
    const dispatch = useDispatch();
    const [search, setSearch] = useState("");
    const [deleteUserId, setDeleteUserId] = useState('');

    useEffect(() => {
        dispatch(fetchUserList());
    }, [dispatch]);

    // Same filter logic as Desktop for consistency
    const filteredUsers = Object.values(users).filter((user) =>
        user.name.toLowerCase().includes(search.toLowerCase()) ||
        user.email.toLowerCase().includes(search.toLowerCase()) ||
        user.phone.toLowerCase().includes(search.toLowerCase()) ||
        roleMap[user.roleId]?.toLowerCase().includes(search.toLowerCase())
    );

    const handleEdit = (user) => {
        dispatch(editUser(user));
        dispatch(openGlobalPopup("edit-user"));
    };

    const handleDeleteClick = (userId) => {
        setDeleteUserId(userId);
        dispatch(openGlobalPopup("confirm-box"));
    };

    return (
        <div className="mobile-list-container">
            <MobileFilterCard
                label={t("Search users")}
                hint={t("Find users by name, phone, email or role.")}
                placeholder={t("Search users...")}
                search={search}
                setSearch={setSearch}
                countText={`${filteredUsers.length} ${t("users")}${search.trim() ? ` ${t("found")}` : ""}`}
            />

            {filteredUsers.length === 0 ? (
                <EmptyScreen message="No users found." />
            ) : (
                <ul className="reservation-list">
                    {filteredUsers.map((user) => (
                        <UserMobileCard
                            key={user.userId}
                            user={user}
                            roleName={roleMap[user.roleId]}
                            onEdit={() => handleEdit(user)}
                            onDelete={() => handleDeleteClick(user.userId)}
                        />
                    ))}
                </ul>
            )}

            <ConfirmBox
                variant="delete"
                title="Are you sure you want to delete this user?"
                onConfirm={() => {
                    if (deleteUserId) {
                        dispatch(deleteUser(deleteUserId));
                    }
                }}
                onCancel={() => setDeleteUserId('')}
            />
        </div>
    );
}

export default UserMobileList;
